// Rails UJS bootstrap
import Rails from '@rails/ujs'

Rails.start()
